import { useEffect } from 'react';
import CeremonyShell from '../CeremonyPage/components/CeremonyShell';
import '../CeremonyPage/CeremonyPage.css';
import '../CeremonyPage/components/ceremony-components.css';
import './ComingSoonPage.css';

const TITLE = 'قريباً';

/**
 * Route: / (the brand mark's destination).
 *
 * Reuses the same purple/glass shell and hero typography as the invitation
 * page (CeremonyShell, .ceremony-hero, .ceremony-hero__badge,
 * .ceremony-hero__subtitle) so tapping the logo feels like a continuation
 * of the same product, not a jump to a different site. The badge itself is
 * static (just the shared entrance fade) — the animation lives on the
 * "قريباً" word instead, via three bouncing dots. See ComingSoonPage.css.
 */
export default function ComingSoonPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = TITLE;
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <CeremonyShell>
      <div className="ceremony-hero">
        <div className="ceremony-hero__badge" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="34" height="34" fill="none" aria-hidden="true" focusable="false">
            <path
              d="M7 3h10M7 21h10M7 3c0 5 5 5 5 9s-5 4-5 9M17 3c0 5-5 5-5 9s5 4 5 9"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h1 className="ceremony-hero__name">
          قريباً
          <span className="coming-soon__dots" aria-hidden="true">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </h1>
        <p className="ceremony-hero__subtitle">نعمل على تجهيز تجربة مميزة لكم.</p>
      </div>
    </CeremonyShell>
  );
}
